import { useContext } from "react";
import { PartnerDashboardContext } from "./PartnerDashboard.context";

export function usePartnerDashboardContext() {
  const context = useContext(PartnerDashboardContext)

  if (!context) {
    throw new Error("useLeadDashboardContext deve ser utilizado apenas dentro de LeadDashboardProvider")
  }

  return context
}